module.exports = __webpack_public_path__ + "img/SelfAdhesive2.3e55e306.jpg";